import { render } from "./index.vue?vue&type=template&id=b2d50706"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/profile/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2d50706"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2d50706', __exports__)) {
    console.log('reload')
    api.reload('b2d50706', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=b2d50706", () => {
    console.log('re-render')
    api.rerender('b2d50706', render)
  })

}


export default __exports__